import postgre from "../images/postgre2.png";
import mysql from "../images/mysql2.png";
import excel from "../images/excel.png";
import tableau from "../images/tableau.svg";
import powerbi from "../images/powerbi.png";
import Python from "../images/Python-logo.png";
import git from "../images/git.png";
import github from "../images/github.png";
import canva from "../images/canva.svg";
import powerquery from "../images/PowerQuery-Logo.png";
import fabric from "../images/ms fabrics.webp";
import docker from "../images/Docker.png";
import lookerstudio from "../images/google-looker-seeklogo.png";

const SkillData = [
  {
    id: "S1",
    title: "MS EXCEL",
    proficiency: "Advanced",
    pic: excel,
  },
  {
    id: "S4",
    title: "POWER BI",
    proficiency: "Advanced",
    pic: powerbi,
  },
  {
    id: "S7",
    title: "PYTHON",
    proficiency: "Intermediate",
    pic: Python,
  },
  {
    id: "S3",
    title: "MY SQL",
    proficiency: "Advanced",
    pic: mysql,
  },
  {
    id: "S2",
    title: "POSTGRE SQL",
    proficiency: "Advanced",
    pic: postgre,
  },
  {
    id: "S5",
    title: "LOOKER STUDIO",
    proficiency: "Advanced",
    pic: lookerstudio,
  },
  {
    id: "S55",
    title: "TABLEAU",
    proficiency: "Beginner",
    pic: tableau,
  },
  {
    id: "S45",
    title: "DOCKER",
    proficiency: "Intermediate",
    pic: docker,
  },
  {
    id: "S6",
    title: "MICROSOFT FABRIC",
    proficiency: "Beginner",
    pic: fabric,
  },
  {
    id: "S8",
    title: "GIT",
    proficiency: "Advanced",
    pic: git,
  },
  {
    id: "S9",
    title: "GITHUB",
    proficiency: "Advanced",
    pic: github,
  },
  {
    id: "S10",
    title: "POWER QUERY",
    proficiency: "Advanced",
    pic: powerquery,
  },
  {
    id: "S11",
    title: "CANVA",
    proficiency: "Advanced",
    pic: canva,
  },
];

export default SkillData;
